<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <v-col cols="4">
              <v-select
                :items="exams"
                v-model="exam"
                label="Chọn kỳ thi"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                hide-details
                @change="examSelected"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="subjects"
                v-model="subject"
                label="Chọn môn thi"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                hide-details
                @change="subjectSelected"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="filteredRoomSubjects"
                v-model="roomSubject"
                label="Chọn số túi"
                item-value="id"
                item-text="roomCode"
                return-object
                outlined
                dense
                class="pr-6"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn
            :disabled="!exam || !roomSubject || !subject"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {},
  data() {
    return {
      exam: '',
      roomSubject: '',
      subject: '',
      exams: [],
      subjects: [],
      roomSubjects: [],
      filteredRoomSubjects: [],
      teacher: {}
    }
  },
  async mounted() {
    await this.getExams()
  },
  methods: {
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('roomSubject', ['fetchRoomSubjects']),
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('teacherExam', ['fetchTeacherExams']),
    onFilterChanged() {
      const params = {
        exam: this.exam.id,
        roomCode: this.roomSubject ? this.roomSubject.roomCode : '',
        subject: this.subject ? this.subject.id : ''
      }
      this.$emit('onFilterChanged', params, this.roomSubject)
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active' })
      this.$loading.active = false
    },

    async getRoomSubjects(query) {
      const results = await this.fetchRoomSubjects(query)
      this.filteredRoomSubjects = results.filter(subject => subject.roomCode)
    },
    async getSubjects(query) {
      this.subjects = await this.fetchSubjects(query)
    },
    async examSelected() {
      this.$loading.active = true
      await this.getSubjects({ exam: this.exam ? this.exam.id : '' })
      if (this.$auth.role.type === 'teacher') {
        const teacherExam = await this.fetchTeacherExams({ teacher: this.$auth.user.teacher, exam: this.exam.id })

        if (teacherExam.length === 0) {
          this.teacher = null
          this.subjects = []
        } else {
          this.teacher = teacherExam[0]
          this.subjects = this.subjects.filter(subject =>
            this.teacher.subjects.some(teacherSubject => teacherSubject.id === subject.id)
          )
        }
      }
      this.$loading.active = false
    },

    async subjectSelected() {
      this.$loading.active = true
      await this.getRoomSubjects({ subject: this.subject.id })
      if (this.$auth.role.type === 'teacher' && this.teacher && this.teacher.rooms) {
        this.filteredRoomSubjects = this.filteredRoomSubjects.filter(room =>
          this.teacher.rooms.some(teacherRoom => teacherRoom.id === room.room.id)
        )
      }
      this.$loading.active = false
    }
  }
}
</script>
